
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/synileiki",
      function () {
        return require("private-next-pages/um/thjonusta/synileiki.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/synileiki"])
      });
    }
  